module.exports = __webpack_public_path__ + "static/media/ball-joints-red.d277ae61.svg";